<template>
  <div id="innercontainer" style="width:98%; height:100%; margin:0 auto">
    <div id="Welcome" align="left">

      <!-- Papers section (always visible) -->
      <p style="font-size:25px; margin-top:10px;">Papers</p>

      <p style="font-size:17px; margin-top:-10px;">
        <strong>Tianle Yang</strong>, Chengzhe Sun, Phil Rose, and Siwei Lyu. (2026).
        "Acoustic and perceptual differences between standard and accented speech and their voice clones."
        <a href="https://arxiv.org/abs/2604.01562">[preprint]</a>
      </p>


      <p style="font-size:17px; margin-top:-10px;">
        <strong>Tianle Yang</strong>, Chengzhe Sun, Phil Rose, Cassandra L Jacobs, and Siwei Lyu. (2026).
        "Assessing the Ability of Neural TTS Systems to Model Consonant-Induced F0 Perturbation."
        Computer Speech & Language, Volume 100, 101983.
        <a href="https://www.sciencedirect.com/science/article/abs/pii/S088523082600046X">[Journal page]</a>, 
        <a href="https://arxiv.org/abs/2603.21078">[preprint]</a>
      </p>

      <p style="font-size:17px; margin-top:-10px;">
        Matthew Faytak, <strong>Tianle Yang</strong>, Pius Wuchu Akumbu, Ivo Forghema Njuasi, and Éric Le Ferrand. (2026).
        "Short-form verbal arts as a speech data resource in the field."
        Proceedings of the Fifth Workshop on NLP Applications to Field Linguistics.
        <a href="https://aclanthology.org/2026.fieldmatters-1.5.pdf">[inproceedings]</a>
      </p>

      <p style="font-size:17px; margin-top:-10px;">
        Matthew Faytak, <strong>Tianle Yang</strong>, and Ivo F. Njuasi. (2026).
        "Acoustic Correlates of Positional Prominence in Kom."
        Proceedings of Speech Prosody 2026.
        <a href="https://www.isca-archive.org/speechprosody_2026/faytak26_speechprosody.pdf">[inproceedings]</a>
      </p>

      <p style="font-size:17px; margin-top:-10px;">
        Chengzhe Sun, <strong>Tianle Yang</strong>, and Siwei Lyu. (2026).
        "A Survey of AI-generated Voices and Their Detection."
        APSIPA Transactions on Signal and Information Processing, 15(1): 76-109.
        <a href="https://www.emerald.com/atsip/article/15/1/76/1359539">[Journal page]</a>,
      </p>
      
      <p style="font-size:17px; margin-top:-10px;">
        <strong>Tianle Yang</strong>, Chengzhe Sun, Siwei Lyu, and Phil Rose. (2025).
        "Forensic deepfake audio detection using segmental speech features."
        Forensic Science International, Volume 379.
        <a href="https://www.sciencedirect.com/science/article/abs/pii/S0379073825004128">[Journal page]</a>, 
        <a href="https://arxiv.org/abs/2505.13847">[preprint]</a>
      </p>

      <p style="font-size:17px; margin-top:-10px;">
        <strong>Tianle Yang</strong> and Matthew Faytak. (2025). 
        "Onset-tone interaction in Mundabli."
        Proceedings of the Linguistic Society of America.
        <a href="https://journals.linguisticsociety.org/proceedings/index.php/PLSA/article/view/5895">[inproceedings]</a>
      </p>

      <p style="font-size:17px; margin-top:-10px;">
        Matthew Faytak, Mariana Quintana Godoy, and <strong>Tianle Yang</strong>. (2024).
        "Lingual and epilaryngeal articulation of vowels in Mundabli."
        ISSP 2024 - 13th International Seminar on Speech Production.
        <a href="https://www.isca-archive.org/issp_2024/faytak24_issp.pdf">[inproceedings]</a>
      </p>

      <p style="font-size:17px; margin-top:-10px;">
        Phil Rose and <strong>Tianle Yang</strong>. (2024).
        "Diagnosing dominance: Problematic sandhi types in the Chinese Wu dialect of Jinshan."
        Proceedings of the Linguistic Society of America.
        <a href="https://journals.linguisticsociety.org/proceedings/index.php/PLSA/article/view/5667">[inproceedings]</a>
      </p>

      <p style="font-size:17px; margin-top:-10px;">
        Phil Rose and <strong>Tianle Yang</strong>. (2022).
        "Modeling Interaction between Tone and Phonation Type in the Northern Wu Dialect of Jinshan."
        18th Australasian International Conference on Speech Science and Technology.
        <a href="/Jinshan_SST.pdf">[inproceedings]</a>
      </p>

      <p style="font-size:17px; margin-top:-10px;">
        <strong>Tianle Yang</strong>. (2022).
        "Neural networks with different initialization methods for depression detection."
        <a href="https://arxiv.org/pdf/2205.04792.pdf">[preprint]</a>
      </p>

      <!-- Talk and poster collapsible section -->
      <button @click="showTalks = !showTalks" style="margin-top:20px; font-size:18px; background:none; border:none; color:#0056b3; cursor:pointer;">
        {{ showTalks ? '▼' : '►' }} Talks and posters
      </button>

      <div v-if="showTalks">
        <p style="font-size:17px; margin-top:10px;">
          <strong>Tianle Yang</strong>, Han Pham, Yixuan Liu, Atharvya Vikas Jadav, Fred Mailhot, and Cassandra Jacobs. (2025).
          "Evidence for duration as the primary cue to English homophone identity in human and machine-generated speech."
          Second annual meeting of PHUNY (Phonetics/Phonology in Upstate NY).
          <span style="color:#0000EE;">[talk]</span>
        </p>

        <p style="font-size:17px; margin-top:-10px;">
          <strong>Tianle Yang</strong> and Kayla Shames. (2025).
          "f0 perturbation and stop place of articulation in Yoruba."
          Second annual meeting of PHUNY (Phonetics/Phonology in Upstate NY).
          <span style="color:#0000EE;">[talk]</span>
        </p>

        <p style="font-size:17px; margin-top:-10px;">
          <strong>Tianle Yang</strong> and Matthew Faytak. (2025). "Onset-tone interaction in Mundabli."
          2025 Linguistic Society of America Annual Meeting.
          <span style="color:#0000EE;">[talk]</span>
        </p>

        <p style="font-size:17px; margin-top:-10px;">
          <strong>Tianle Yang</strong>. (2024). "Acoustic analysis of Mundabli tones in monosyllabic words."
          First annual meeting of PHUNY (Phonetics/Phonology in Upstate NY).
          <span style="color:#0000EE;">[talk]</span>
        </p>

        <p style="font-size:17px; margin-top:-10px;">
          <strong>Tianle Yang</strong> and Phil Rose. (2024). "Left dominant or right dominant? Problematic sandhi types in the Chinese Wu dialect of Jinshan."
          2024 Linguistic Society of America Annual Meeting.
          <a href="/Jinshan_dominance_abstract.pdf">[abstract]</a> and 
          <a href="/dominance_poster_LSA.pdf">[poster]</a>
        </p>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeComponent',
  data() {
    return {
      showTalks: false
    }
  }
}
</script>
